import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { hookFormZod } from '@ipfabric/ui-components/utils/hookForm/hookFormZod';
import { sessionTimeouts } from '@ipfabric/utils';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export type CommandResponseFieldValues = { commandResponse: string };
export type CommandResponseOutputValues = { commandResponse: number };

export const commandResponse: FormSnippet<
  DiscoverySettingsObject,
  CommandResponseFieldValues,
  CommandResponseOutputValues
> = {
  render: ({ form }) => (
    <FormTextField
      control={form.control}
      type='number'
      name='commandResponse'
      description='Time to wait for a device to finish sending the response to a command'
      label='Command response'
      endAdornment='minutes'
      inputWidthClassName='w-60'
    />
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.commandResponse =
      model.timeouts?.command?.toString() ?? '';
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.timeouts ??= {};
    modelDraft.timeouts.command = transformedValues.commandResponse;
  },
  schema: z.object({
    commandResponse: hookFormZod.numberInputWith(
      hookFormZod.minMax(sessionTimeouts.min, sessionTimeouts.max),
    ),
  }),
};
